import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';

type Props = {
  lawyerHasRetired: boolean;
  lawyerName: string;
};

export const LawyerSummary: FC<Props> = ({ lawyerHasRetired, lawyerName }) => (
  <p>
    {lawyerHasRetired ? (
      <FormattedMessage
        id="LawyerSummary/retiredLawyer"
        values={{ name: lawyerName }}
      />
    ) : (
      <FormattedMessage
        id="LawyerSummary/lawyer"
        values={{ name: lawyerName }}
      />
    )}
  </p>
);
